/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import styled, { css } from 'styled-components'

import { useMediaScreenType } from 'src/hooks/useMediaScreenType'

import * as Fragments from './fragments'
import automataLogoImage from '../../assets/automata-logo.png'
import tgbLogoImage from '../../assets/tgb-logo.png'
import { pxToVw } from '../../functions/units'
import BrandLogo from '../Common/BrandLogo'
import FlexBox from '../Common/FlexBox'
import DonationHistoryButton from './fragments/DonationHistoryButton'

const NavBarContainer = () => {
  const screenType = useMediaScreenType()

  return (
    <>
      <StyledNavBarWrap>
        <StyledContainer alignItems="center" justifyContent="space-between">
          <FlexBox columnGap={16} alignItems="center">
            <a href="https://www.ata.network/" target="_blank" rel="noreferrer">
              <BrandLogo altText="Automata logo" logo={automataLogoImage} />
            </a>
            <StyledCollabX>x</StyledCollabX>
            <a href="https://thegoodblockchain.sg/" target="_blank" rel="noreferrer">
              <BrandLogo altText="The Good Blockchain logo" logo={tgbLogoImage} />
            </a>
          </FlexBox>

          {screenType.isDesktop ? (
            <FlexBox alignItems="center" columnGap={10}>
              <Fragments.Coupons />
              <Fragments.FaqButton />
              <DonationHistoryButton />
              <Fragments.Wallet />
            </FlexBox>
          ) : (
            <Fragments.FaqButton />
          )}
        </StyledContainer>
      </StyledNavBarWrap>

      {screenType.isMobile && (
        <StyledMobileNavBarWrap columnGap={10} alignItems="center" justifyContent="center">
          <Fragments.Coupons />
          <DonationHistoryButton />
          <Fragments.Wallet />
        </StyledMobileNavBarWrap>
      )}
    </>
  )
}

export default NavBarContainer

const StyledNavBarWrap = styled.header`
  height: ${pxToVw(100)};

  ${({ theme }) => css`
    background-color: ${theme.colors.bg};
    box-shadow: ${theme.shadows.topNavBar};

    ${theme.mediaQuery.mobile`
      height: ${pxToVw(100, 720)};
    `}
  `}
`

const StyledContainer = styled(FlexBox)`
  height: 100%;
  padding-inline: ${pxToVw(250)};

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      padding-inline: ${pxToVw(60, 720)};
    `}
  `}
`

const StyledMobileNavBarWrap = styled(FlexBox)`
  width: 100vw;
  position: fixed;
  left: 0;
  bottom: 0;
  height: ${pxToVw(100, 720)};
  background-color: ${({ theme }) => theme.colors.bg};
  z-index: 3;
`

const StyledCollabX = styled.span`
  margin-left: ${pxToVw(4)};
  color: ${({ theme }) => theme.colors.gray300};
  font-weight: 500;
  font-size: ${pxToVw(26)};

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      margin-left: ${pxToVw(4)};
      font-size: ${pxToVw(26, 720)};
    `}
  `}
`
